import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppLogger } from '@workivate/tho-web-shared';
import { IS_PRODUCTION } from 'utils/check-environment/check-environment';
import { App } from './App';

// Default to debug logging in non-production; can be overridden by setting debugLogsOn=false in localStorage
if (!IS_PRODUCTION && localStorage.getItem('debugLogsOn') === null) {
  localStorage.setItem('debugLogsOn', 'true');
}
AppLogger.configure({ isProduction: IS_PRODUCTION });

// Initialize any global scripts
if (typeof window !== 'undefined') {
  // Initialize gtag if measurement ID exists
  const measurementId = import.meta.env.ANALYTICS_MEASUREMENT_ID;
  if (measurementId && window.gtag) {
    window.gtag('config', measurementId);
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
